import { AuthResponse } from '../../lib/types/models/auth/login'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient, switchSession } from '../rest-api-client'

export const reconnect = async () => {
  return switchSession(() =>
    restApiClient
      .url(constructApiUrl(API.auth.reconnect.url, null))
      .options({ sessionSwitch: true })
      .post<AuthResponse>()
  )
}
